import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import {withRouter } from 'react-router-dom';

import ogImg from '../../assets/img/og.jpg';

import Image from '../../components/shared/backgroundImage';

import Footer from '../../components/shared/Footer';
import NavBar from '../../components/shared/NavBar';
import Description from '../../components/shared/imageDescription';
import NewsAndInfo from '../../components/shared/newsAndInfo';
import QuickLinks from '../../components/shared/quicklinks';
import Files from '../../components/shared/filesAndDocuments.js';
import Explore from '../../components/shared/explore.js';

import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import {
  getCurrentExperience,
  getDepartmentVisibilityTokens,
  normalizeVisibilityTokens,
} from '../../utils/visibility';

class generic extends Component { 
  constructor(props) {
    super(props);
    this.onTransitionEnd.bind(this);
    this.state = {
      index: null,
      data: null,
      loaded: false,
      transitionEnded: false,
    };
  }

  onTransitionEnd = () => {
    this.setState({ transitionEnded: true }); 
  };

  toVisibilityTokens = (raw) => {
    return normalizeVisibilityTokens(raw);
  };

  // Normalize experience strings to tokens like "internal" / "seasonal"
  getExperienceValue = () => {
    return this.toVisibilityTokens(getCurrentExperience('', null));
  };

  // Resolve visibility from the department entry mapped by route.
  getPageVisibilityValue = (page, routeOverride = null) => {
    if (!page) return [];
    return getDepartmentVisibilityTokens(page.department, routeOverride);
  };

  componentDidUpdate(){
    let location = this.props.location.pathname;
    location = location.toLowerCase();
    let path;

    if (this.state.index == null){
      if (this.data){
        path = this.data.genericPageWithNews;
        const targetRoute = location.replace('/departments/', '');
        const matches = [];

        for (let i = 0; i < path.length; i++) {
          const pageRouteMatch = String(path[i].route || '').toLowerCase() === targetRoute;
          const dept = path[i] && path[i].department;
          const deptRouteMatch = Array.isArray(dept)
            ? dept.some((d) => String((d && d.route) || '').toLowerCase() === targetRoute)
            : String((dept && dept.route) || '').toLowerCase() === targetRoute;

          if (pageRouteMatch || deptRouteMatch) {
            matches.push({ item: path[i], index: i });
          }
        }

        if (matches.length > 0) {
          const userExperience = this.getExperienceValue(); // ["internal"] / ["seasonal"] / []
          const matchDebug = matches.map((m) => ({
            route: m.item && m.item.route,
            pageExperience: this.getPageVisibilityValue(m.item, targetRoute),
          }));

          // Prefer a match that is visible to this user experience.
          const allowed = matches.find((m) => {
            const pageExperience = this.getPageVisibilityValue(m.item, targetRoute); // ["internal","seasonal"] / []

            // If we cannot resolve either side, do not hard-block.
            if (userExperience.length === 0 || pageExperience.length === 0) return true;

            return userExperience.some((exp) => pageExperience.includes(exp));
          });

          if (allowed) {
            this.setState({ index: allowed.index });
            return;
          }

          // Route back to home only when we found route matches but none are allowed.
          console.warn('Department access denied; redirecting home', {
            location,
            targetRoute,
            userExperience,
            matchDebug,
          });
          if (this.props.history && this.props.history.replace){
            this.props.history.replace('/');
          } else {
            window.location.href = '/';
          }
          return;
        }
      }
    }
  }

  render() {
    const heroClasses = classnames('hero', {
      animate: this.state.transitionEnded
    });
    if (!this.props.genericPageQuery){
      return <div className="u-hidden"> Waiting</div>;
    }

    else if ((this.props.genericPageQuery && this.props.genericPageQuery.loading)) { 
      return <div className="u-hidden">Loading</div>; 
    }

    else if (this.props.genericPageQuery && this.props.genericPageQuery.error) {
      return <div className="u-hidden">Error </div>;
    }

    else {
      this.data = this.props.genericPageQuery;
      if (!this.data) {
        window.location.href = '/404';
        return null;
      } 
      else{
        if (this.state.index != null){
          return(
            <div key="home" className={heroClasses}>   
              <p className='hidden'> department: {this.props.location.pathname}</p>
              <Helmet>
                <meta property="og:image" content={ogImg}/>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
              </Helmet>
              <header id="site-header" className="container" role="banner">
                <a id="site-title" className="h1" href="/"> <img src={this.data.globalSites[0].cubsLogo.url} alt = "site-header"/></a>
                <Image introBackgrounds={this.data.genericPageWithNews[this.state.index]}/>
                <NavBar NavBar={this.data.globalSites[0].mainNavigation} />
                <div className="header-content">
                  <div className="row2 padding-bottom">
                    <Description description= {this.data.genericPageWithNews[this.state.index]}/>
                  </div>
                </div>
              </header>
              <main className="container">
                {this.data.genericPageWithNews[this.state.index].pageDescription && 
                  <section className= 'section'>
                    <div className= 'row'>
                      <ReactMarkdown className="markdown-body" remarkPlugins={[remarkBreaks]} rehypePlugins={[rehypeRaw]}>{this.data.genericPageWithNews[this.state.index].pageDescription}</ReactMarkdown>
                    </div>
                  </section>
                }
                <section className= 'section' style={{borderTop: "none"}}>
                  <div className= 'row'>
                    <NewsAndInfo news={this} header={this.data.genericPageWithNews[this.state.index].newsAndInformationHeader ? this.data.genericPageWithNews[this.state.index].newsAndInformationHeader : 'NEWS & INFORMATION'}/>
                    <QuickLinks links={this.data.genericPageWithNews[this.state.index]}/>
                  </div>
                  <div className='row'>
                    <Files files={this.data.genericPageWithNews[this.state.index]}/>
                  </div>
                </section>
                <Explore explore={this.data.exploreComponents[0]}/>
              </main>
              <Footer footer={this.data.globalSites[0].mainNavigation}/>
            </div>
          );
        }
        else{
          return <div className="u-hidden">Loading</div>; 
        }
      }
    }
  }
}

export default withRouter(generic);
